var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{on:{"click":_vm.changeServer}},[_c('strong',[_vm._v(_vm._s(_vm.$t('therms.data-server'))+" : ")]),_vm._v(_vm._s(_vm.server)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }